import { Grid, TextField } from '@mui/material'
import ConfirmationDialog from './ConfirmationDialog'
import Input from 'components/form/Input'
import { ChangeEvent, useState } from 'react'

interface ChangeTextDialogProps {
  open: boolean
  setOpen: (b: boolean) => void
  title: string
  text: string
  onApprove: (s: string) => void
  placeholder: string
}

interface ChangeTextDialogContentProps extends ChangeTextDialogProps {
  onSetText: (s: string) => void
  text: string
}

function ChangeTextDialogContent(props: ChangeTextDialogContentProps) {
  const onFirstNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onSetText(event.target.value)
  }

  return (
    <Grid item style={{ width: '400px' }}>
      <TextField
        variant="outlined"
        placeholder={props.placeholder}
        value={props.text}
        onChange={onFirstNameChange}
        multiline
        rows={4} // Adjust the number of rows as needed
        fullWidth
      />
    </Grid>
  )
}

export default function ChangeTextDialog(props: ChangeTextDialogProps) {
  const [text, onSetText] = useState(props.text)
  return (
    <ConfirmationDialog
      title={props.title}
      handleClose={() => props.setOpen(false)}
      handleRightButton={() => {
        props.onApprove(text)
        props.setOpen(false)
      }}
      handleLeftButton={() => {
        props.setOpen(false)
      }}
      content={
        <ChangeTextDialogContent {...props} text={text} onSetText={onSetText} />
      }
      open={props.open}
    />
  )
}
